module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/icon-woman-d8d0b83b860153339cea7e94fca86dd9.png";